import React from 'react';
import './ListEditor.css';

// list 타입 필드 에디터
// itemType: 'string' | 'number'
const ListEditor = ({ value = [], onChange, itemType = 'string', disabled = false }) => {
  const addItem = () => {
    const newItem = itemType === 'number' ? 0 : '';
    onChange([...value, newItem]);
  };

  const updateItem = (index, newValue) => {
    const updated = [...value];
    updated[index] = itemType === 'number' ? (newValue === '' ? '' : Number(newValue)) : newValue;
    onChange(updated);
  };

  const removeItem = (index) => {
    onChange(value.filter((_, i) => i !== index));
  };

  return (
    <div className="list-editor">
      {value.map((item, index) => (
        <div key={index} className="list-editor-item">
          {itemType === 'number' ? (
            <input
              type="number"
              className="list-editor-input"
              value={item}
              onChange={(e) => updateItem(index, e.target.value)}
              disabled={disabled}
            />
          ) : (
            <textarea
              className="list-editor-input list-editor-textarea"
              value={item}
              onChange={(e) => updateItem(index, e.target.value)}
              rows={2}
              disabled={disabled}
            />
          )}
          {!disabled && (
            <button
              type="button"
              className="list-editor-remove-btn"
              onClick={() => removeItem(index)}
              aria-label="항목 삭제"
            >
              ✕
            </button>
          )}
        </div>
      ))}
      {!disabled && (
        <button
          type="button"
          className="list-editor-add-btn"
          onClick={addItem}
        >
          + 항목 추가
        </button>
      )}
    </div>
  );
};

export default ListEditor;
